/*
 * File: /src/router/routes/tags.js
 * Created Date: Saturday November 14th 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 14th November 2020 8:55:51 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */

const TagsList = () =>
  import(/* webpackChunkName: "TagsList" */ 'src/components/Dashboard/Views/Contacts/Tags/TagList.vue');

export const tagsRoutes = [
  {
    path: 'contacts/tags',
    name: 'Tags',
    component: TagsList
  }
];
